// src/createEmotionCache.js
import createCache from "@emotion/cache";

// Create a cache with a custom key to avoid conflicts with other instances
export default function createEmotionCache() {
  return createCache({ key: "css" });
}
